module.exports = __webpack_public_path__ + "img/pgslot.8d3745d9.png";